import React, { useEffect, useState } from "react";
import { textMessageAPI } from "api/Interactions/TextMessagesAPI";
import { TextMessage } from "api/Interactions/InteractionsInterfaces";
import TextMessageEmptyPage from "./TextMessagesEmptyPage";
import GenericDetailPage from "components/Interactions/GenericDetailPage";

export default function TextMessageDetailPage({ messageId, onClose }: { messageId: number; onClose?: () => void }) {
  const [record, setRecord] = useState<TextMessage | null>(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const numberOfTexts = record?.people?.length || 0;
  const costPerText = 0.05;

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const data = await textMessageAPI.getById(messageId);
      setRecord(data);
      setLoading(false);
    };
    load();
  }, [messageId]);

  const handleUpdate = async (id: number, field: keyof TextMessage, value: any) => {
    setSaving(true);
    const updated = await textMessageAPI.updateField(id, field, value);
    setRecord(updated);
    setSaving(false);
  };

  const handleToggleFulfilled = async () => {
    if (!record) return;
    await handleUpdate(record.id, "pathways_fulfilled", !record.pathways_fulfilled);
  };

  if (!record && !loading) return <TextMessageEmptyPage />;

  return (
    <GenericDetailPage
      record={record}
      loading={loading}
      saving={saving}
      onClose={onClose}
      onUpdate={handleUpdate}
      onToggleFulfilled={handleToggleFulfilled}
      fulfilled={!!record?.pathways_fulfilled}
      fulfillmentDetailsLabel="Text Messages"
      numberOfItems={numberOfTexts}
      costPerItem={costPerText}
      fulfilledByPathwaysAvailable={false}
      registration={false}
      contentDetailFields={[
        { label: "Message", value: record?.message || "", field: "message", multiline: true, rows: 4 },
      ]}
    />
  );
}
